import validate from 'validate.js';

const validateBaseRate = (values) => {
  const { policy1, policy2, policy3, policy4 } = values;
  return {
    policy1: validate.single(policy1,
      {
        presence: { allowEmpty: false },
        inclusion: {
          within: [true]
        }
      }),
    policy2: validate.single(policy2,
      {
        presence: { allowEmpty: false },
        inclusion: {
          within: [true]
        }
      }),
    policy3: validate.single(policy3,
      {
        presence: { allowEmpty: false },
        inclusion: {
          within: [true]
        }
      }),
    policy4: validate.single(policy4,
      {
        presence: { allowEmpty: false },
        inclusion: {
          within: [true]
        }
      })
  };
};

export default validateBaseRate;
